import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";

class ListaSustanciasGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.handleReportesPage = this.handleReportesPage.bind(this);

    this.state = {
      workingGrid: false,
      reporte_productos: [],
      paginas: 0,
      registros: 0,
      paginaActual: 0,

      buscarProductos: {},
      paises: Api.loadCatalogue("countries"),
      nivelUsuario: localStorage.nivel_actual,
    };
  }

  mi_grid = {};
  componentDidMount() {
    // si el usuario no es nivel cuarentena redireccionamos a home
    if (!["3", "6"].includes(this.state.nivelUsuario)) {
      window.location.href = "/";
    }

    this.setReportesProductosPage(1);

    /* let grid = {
      source: "app/listaSustanciaImportaciones",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        nombre_comercial: {
          label: "NOMBRE COMERCIAL",
          render: (me) => {
            if (me.data.nombre_comercial !== null) {
              me.innerHTML = me.data.nombre_comercial;
            } else {
              me.innerHTML = "";
            }
          },
        },
        fabricante: {
          label: "FABRICANTE",
          render: (me) => {
            if (me.data.fabricante !== null) {
              me.innerHTML = me.data.fabricante;
            } else {
              me.innerHTML = "";
            }
          },
        },
        importador: {
          label: "IMPORTADOR",
          render: (me) => {
            if (me.data.importador !== null) {
              me.innerHTML = me.data.importador;
            } else {
              me.innerHTML = "";
            }
          },
        },
        pais: {
          label: "PAÍS DE ORIGEN",
          render: (me) => {
            if (me.data.pais !== null) {
              me.innerHTML = me.data.pais;
            } else {
              me.innerHTML = "";
            }
          },
        },
        cantidad: {
          label: "CANTIDAD",
          render: (me) => {
            if (me.data.categorizacion !== null) {
              me.innerHTML = me.data.cantidad;
            } else {
              me.innerHTML = "";
            }
          },
        },
        ingreso_aduana: {
          label: "FECHA INGRESO ADUANA",
          render: (me) => {
            me.innerHTML = me.data.ingreso_aduana
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
        ingreso_bodega: {
          label: "FECHA INGRESO BODEGA",
          render: (me) => {
            me.innerHTML = me.data.ingreso_bodega
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-")
              .replaceAll("-", "/");
          },
        },
      },
    }; */

    //this.mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      /*onchange: (me, data, serial) => {
                mi_grid.go(1, serial);
            },*/
      render: (form) => {
        /** Cargamos el combo de pais */
        let paises = this.state.paises;
        let option_p = "<option value=''>Seleccione país</option>";
        for (let p in paises) {
          option_p += `<option value="${paises[p].id}">
                        ${paises[p].descripcion}
                    </option>`;
        }
        form.querySelector("#pais").innerHTML = option_p;
        /* Fin de la carga país */
      },

      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "nombre_comercial",
            label: "Nombre comercial",
            placeHolder: "Nombre comercial",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "fabricante",
            label: "Fabricante",
            placeHolder: "Fabricante",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "text",
            name: "importador",
            label: "Importador",
            placeHolder: "Importador",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "pais",
            label: "País de origen",
            placeHolder: "País de origen",
            cols: 3,
            value: "",
          },
        },
        {
          input: {
            type: "number",
            name: "cantidad",
            label: "Cantidad",
            placeHolder: "Cantidad",
            cols: 2,
            autoComplete: "off",
            maxLength: "4",
            min: "1",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha",
            label: "Fecha aduana desde",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha2",
            label: "Fecha aduana hasta",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha3",
            label: "Fecha bodega desde",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "date",
            name: "fecha4",
            label: "Fecha bodega hasta",
            cols: 2,
            value: "",
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 2,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarProductos: busqueda.data() });
              /* let search = this.state.buscarProductos;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              } */
              this.setReportesProductosPage(1);
              //this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });
  }

  setReportesProductosPage(page) {
    this.setState({ workingGrid: true });
    let search = this.state.buscarProductos;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/listaSustanciaImportaciones?page=" + page + src).then((i) => {
      this.setState({
        reporte_productos: i.data,
        paginas: i.last_page,
        registros: i.total,
        paginaActual: i.current_page,
        workingGrid: false,
      });
    });
  }

  handleReportesPage(e) {
    this.setReportesProductosPage(e.target.value);
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/reportes-importacion-general">Reportes</Link>
          </li>
          <li className="breadcrumb-item">Reportes importación</li>
        </ol>
        <h1 className="page-header">
          Reportes importación medicamentos controlados
        </h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                {/* <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div> */}
                {/* EMPIEZA LA TABLA */}
              <div className="table-responsive">
                <fieldset>
                <div id="busqueda"></div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">NOMBRE COMERCIAL</th>
                      <th className="text-center">FABRICANTE</th>
                      <th className="text-center">IMPORTADOR</th>
                      <th className="text-center">PAÍS DE ORIGEN</th>
                      <th className="text-center">CANTIDAD</th>
                      <th className="text-center">FECHA INGRESO ADUANA</th>
                      <th className="text-center">FECHA INGRESO BODEGA</th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.reporte_productos && this.state.reporte_productos.length > 0 ? (
                      this.state.reporte_productos.map((rp) => (
                        <tr>
                          <td>{rp.nombre_comercial !== null ? rp.nombre_comercial : ""}</td>
                          <td>{rp.fabricante !== null ? rp.fabricante : ""}</td>
                          <td>{rp.importador !== null ? rp.importador : ""}</td>
                          <td>{rp.pais !== null ? rp.pais : ""}</td>
                          <td>{rp.cantidad !== null ? rp.cantidad : ""}</td>
                          <td>{rp.ingreso_aduana !== null ? rp.ingreso_aduana.split("-")
                                  .reverse()
                                  .join("-")
                                  .replaceAll("-", "/") : ""}</td>
                          <td>{rp.ingreso_bodega !== null ? rp.ingreso_bodega.split("-")
                                  .reverse()
                                  .join("-")
                                  .replaceAll("-", "/") : ""}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td className="text-center">No hay datos</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setReportesProductosPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual - 1 > 0) {
                            this.setReportesProductosPage(this.state.paginaActual - 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual} de {this.state.paginas}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas >=
                            this.state.paginaActual + 1
                          ) {
                            this.setReportesProductosPage(this.state.paginaActual + 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setReportesProductosPage(this.state.paginas);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleReportesPage}
                      type="number"
                      min="1"
                      max={this.state.paginas}
                      value={this.state.paginaActual}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
                {/* TERMINA LA TABLA */}
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}

export default ListaSustanciasGeneral;
